/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchValidateVehiclesColors = (data) => {
  return apiActionCreator({
    'endpoint': '/budgets/vehicle-prices/validate',
    'authenticated': true,
    'types': [
      ActionTypes.VALIDATING_PRICES_DATA,
      ActionTypes.VALIDATED_PRICES_DATA,
      [
        ActionTypes.VALIDATE_PRICES_DATA_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });
};

export const saveMultipleColorPrices = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/vehicle-prices/save',
      'authenticated': true,
      'types': [
        ActionTypes.SAVING_MULTIPLE_COLOR_PRICES,
        [
          ActionTypes.SAVED_MULTIPLE_COLOR_PRICES,
          MessageActions.addMessageBoxInfo('Precios creados con éxito'),
        ],
        [ActionTypes.SAVE_MULTIPLE_COLOR_PRICES_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const cleanPricesValidationData = () => ({
  'type': ActionTypes.CLEAN_PRICES_DATA,
  'payload': null,
});
